import { render } from "./DocumentsChecking.vue?vue&type=template&id=bfa68a70&scoped=true"
import script from "./DocumentsChecking.vue?vue&type=script&lang=js"
export * from "./DocumentsChecking.vue?vue&type=script&lang=js"

import "./DocumentsChecking.vue?vue&type=style&index=0&id=bfa68a70&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa68a70"]])

export default __exports__